import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$axios = axios.create({
  withCredentials: true
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/**
 * 金額をカンマ区切りに表示します。
 * @param val 金額
 */
Vue.filter('addComma', function(val){
	return val.toLocaleString();
});
